import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_auto",
  "use": "icon-video_auto-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" class=\"design-iconfont\" id=\"icon-video_auto\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <rect stroke=\"#111A34\" stroke-width=\"1.5\" stroke-linejoin=\"round\" x=\"5\" y=\"7\" width=\"20\" height=\"16\" rx=\"4\" />\n    <path fill=\"#111A34\" d=\"M8 11H17V12.6H8z\" />\n    <path fill=\"#111A34\" d=\"M8 15H22V16.6H8z\" />\n    <path fill=\"#111A34\" d=\"M19 11H21V12.6H19z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol